var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreateJobTabIconTask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 16.05H9.10832C8.73332 16.05 8.42499 15.7417 8.42499 15.3667C8.42499 14.9917 8.73332 14.6833 9.10832 14.6833H16.6667C17.0417 14.6833 17.35 14.9917 17.35 15.3667C17.35 15.75 17.0417 16.05 16.6667 16.05Z",
    fill: "#253D87"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 10.8083H9.10832C8.73332 10.8083 8.42499 10.5 8.42499 10.125C8.42499 9.74998 8.73332 9.44165 9.10832 9.44165H16.6667C17.0417 9.44165 17.35 9.74998 17.35 10.125C17.35 10.5 17.0417 10.8083 16.6667 10.8083Z",
    fill: "#253D87"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 5.55832H9.10832C8.73332 5.55832 8.42499 5.24998 8.42499 4.87498C8.42499 4.49998 8.73332 4.19165 9.10832 4.19165H16.6667C17.0417 4.19165 17.35 4.49998 17.35 4.87498C17.35 5.24998 17.0417 5.55832 16.6667 5.55832Z",
    fill: "#253D87"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.09166 6.69168C3.90833 6.69168 3.73333 6.61668 3.60833 6.49168L2.84999 5.73335C2.58333 5.46668 2.58333 5.03335 2.84999 4.76668C3.11666 4.50002 3.54999 4.50002 3.81666 4.76668L4.09166 5.04168L5.87499 3.25835C6.14166 2.99168 6.57499 2.99168 6.84166 3.25835C7.10833 3.52502 7.10833 3.95835 6.84166 4.22502L4.57499 6.49168C4.44166 6.61668 4.27499 6.69168 4.09166 6.69168Z",
    fill: "#253D87"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.09166 11.9417C3.91666 11.9417 3.74166 11.875 3.60833 11.7417L2.84999 10.9833C2.58333 10.7167 2.58333 10.2834 2.84999 10.0167C3.11666 9.75002 3.54999 9.75002 3.81666 10.0167L4.09166 10.2917L5.87499 8.50835C6.14166 8.24168 6.57499 8.24168 6.84166 8.50835C7.10833 8.77502 7.10833 9.20835 6.84166 9.47502L4.57499 11.7417C4.44166 11.875 4.26666 11.9417 4.09166 11.9417Z",
    fill: "#253D87"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.09166 16.9417C3.91666 16.9417 3.74166 16.875 3.60833 16.7417L2.84999 15.9834C2.58333 15.7167 2.58333 15.2834 2.84999 15.0167C3.11666 14.75 3.54999 14.75 3.81666 15.0167L4.09166 15.2917L5.87499 13.5083C6.14166 13.2417 6.57499 13.2417 6.84166 13.5083C7.10833 13.775 7.10833 14.2084 6.84166 14.475L4.57499 16.7417C4.44166 16.875 4.26666 16.9417 4.09166 16.9417Z",
    fill: "#253D87"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateJobTabIconTask);
export default __webpack_public_path__ + "static/media/create_job_tab_icon_task.268d7b7eb7004797446a68553ce0f97d.svg";
export { ForwardRef as ReactComponent };